<template>
  <a-modal
    title="重置密码"
    :maskClosable="false"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :cancelText="'取消'"
    :okText="'确定'"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-form layout="horizontal" :form="form">
      <!-- 密码 -->
      <a-form-item label="密码" 
        :labelCol="{lg: {span: 7}}"
        :wrapperCol="{lg: {span: 13}}"
        >
        <a-input type="password" 
          placeholder="请输入"  
          v-decorator="['password', {rules: [{ required: true, message: '' },{ validator: handleConfirmPass }], validateTrigger: 'change'}]"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import person from '../../api/person'

export default {
  name: 'personFormModal',
  data(){
    return{
      form: this.$form.createForm(this),
      visible: false,
      personId: '',
      confirmLoading: false,
    }
  },
  methods:{
    handleConfirmPass(rule, value, callback) {
      if (!value) {
        callback(
          '请输入8-20位密码，需包含大小写字母、数字，字符不支持中文格式。'
        )
      } else if (!/^[\u0020-\u007e]{8,20}$/.test(value)) {
        callback('请输入长度为8~20位的密码')
      } else if (!/[A-Z]+/.test(value)) {
        callback('密码中需要包含大写字母')
      } else if (!/[a-z]+/.test(value)) {
        callback('密码中需要包含小写字母')
      } else if (!/\d+/.test(value)) {
        callback('密码中需要包含数字')
      }
      callback()
    },
    //隐藏
    handleCancel() {
      this.visible = false;
      this.$emit("closeForm");
    },

    init(params){
      this.visible = true;
      this.personId = params.id;
    },

    //提交操作
    handleSubmit(e){
      e.preventDefault();
      this.form.validateFields((err, value) => {
        if (!err) {
          this.resetPassword(value.password)
        }
      })
    },

    //重置密码
    resetPassword(password){
      let req = {
        id: this.personId,
        password: password,
      }
      person.resetPassword(req).then(res=>{
        this.$message.success('修改密码成功')
        this.handleCancel();
      })
    }
  },
  created(){
  }


}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
  .cl-inner{
    width: calc(100% - 40px);
    padding: 50px 20px 30px;
    background: white;
    margin: 20px auto;
  }
  .ap-form{
    width: 400px;
  }
  .form-oper{
    text-align: center;
    button{
      margin: 0px 5px;
    }
  }
</style>